import React from 'react'
import { useDispatch } from 'react-redux'
import * as Yup from 'yup'
import { Container } from '@mui/material'
import AppForm from '../form/AppForm'
import AppInput from '../form/AppInput'
import SubmitButton from '../form/SubmitButton'
import Header from '../form/Header'
import { formTypeList } from '../../constants/form'
import { addNewBanner, updateBanner } from '../../store/actions/bannerAction'
import AppCheckbox from '../form/AppCheckbox'

const validationSchema = Yup.object().shape({
    title: Yup.string().required().label('Title'),
    details: Yup.string().required().label('Details'),
    picLink: Yup.string().required().label('Picture Link'),
    sort: Yup.number().required().label('Sort'),
})

const BannerForm = ({ formType, setOpen, propsValue = null }) => {
    const dispatch = useDispatch()
    return (
        <Container>
            <Header
                title={`${formType === formTypeList.NEW ? 'ADD' : ''}${
                    formType === formTypeList.EDIT ? 'EDIT' : ''
                } BANNER`}
            />
            <AppForm
                initialValues={{
                    title: propsValue ? propsValue.title : '',
                    details: propsValue ? propsValue.details : '',
                    picLink: propsValue ? propsValue.picLink : '',
                    sort: propsValue ? propsValue.sort : 1,
                    enabled: propsValue ? propsValue.enabled : true,
                }}
                onSubmit={(values) => {
                    const submitValues =
                        formType === formTypeList.NEW
                            ? values
                            : { ...propsValue, ...values }
                    formType === formTypeList.NEW
                        ? dispatch(addNewBanner(submitValues))
                        : dispatch(updateBanner(submitValues))
                    setOpen(false)
                }}
                validationSchema={validationSchema}
            >
                <AppInput
                    name="title"
                    label="Title"
                    type="text"
                    inputProps={{
                        maxLength: 200,
                    }}
                    required={true}
                />
                <AppInput
                    required={true}
                    name="details"
                    label="Details"
                    multiline
                    rows={5}
                />
                <AppInput
                    name="picLink"
                    label="Picture Link"
                    type="text"
                    inputProps={{
                        maxLength: 200,
                    }}
                    required={true}
                />
                <AppInput
                    name="sort"
                    label="Sort"
                    type="number"
                    inputProps={{ maxLength: 10 }}
                    required={true}
                />
                <AppCheckbox name="enabled" label="Enabled" />
                <SubmitButton title="Submit" />
            </AppForm>
        </Container>
    )
}

export default BannerForm
